import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"mb-n4 mt-n3",attrs:{"fluid":""}},[_c(VBreadcrumbs,{staticClass:"breadcrumbs",attrs:{"items":_vm.breadcrumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }